import { takeEvery, put, call } from "redux-saga/effects"
import apiCall from "../services"

const apiUrl = process.env.REACT_APP_API_URL
const enviromentUrl = process.env.REACT_APP_ENVIROMENT

const getSetCookie = () => {
  return window.localStorage.getItem("uuidSetCookie")
}

function* getGuestDirectoryList(actions) {
  const uuid = getSetCookie()
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    }

    const requestOptions = {
      headers: headers,
    }

    let url = apiUrl + "/opa-hotel-directory-entries"
    let params = []

    if (actions.query) {
      let q = actions.query
      if (q.startsWith("?")) q = q.substring(1)
      params.push(q)
    } else {
      params.push(`page=${actions.page || 1}`)
    }

    params.push("include=category,images,files")
    url += "?" + params.join("&")

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`
      } else {
        url += `?env=${enviromentUrl}`
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions)

    yield put({ type: "LIST_GUEST_DIRECTORY_RESPONSE_GET", value: response })
  } catch (error) {
    yield put({ type: "LIST_GUEST_DIRECTORY_RESPONSE_GET", value: error })
  }
}

function* getGuestDirectory(actions) {
  const uuid = getSetCookie()
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    }

    const requestOptions = {
      headers: headers,
    }

    let url =
      actions.query === null
        ? apiUrl + "/opa-hotel-directory-entries"
        : apiUrl + "/opa-hotel-directory-entries/" + actions.query + "?include=category,images,files"

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`
      } else {
        url += `?env=${enviromentUrl}`
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions)

    yield put({ type: "GUEST_DIRECTORY_RESPONSE_GET", value: response })
  } catch (error) {
    yield put({ type: "GUEST_DIRECTORY_RESPONSE_GET", value: error })
  }
}

function* getGuestDirectoryCategoryList(actions) {
  const uuid = getSetCookie()
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    }

    const requestOptions = {
      headers: headers,
    }

    let url = apiUrl + "/opa-hotel-directory-categories"
    let params = []

    if (actions.query) {
      let q = actions.query
      if (q.startsWith("?")) q = q.substring(1)
      params.push(q)
    } else if (actions.page !== undefined) {
      params.push(`page=${actions.page}`)
    } else {
      params.push("page=1")
    }

    url += "?" + params.join("&")

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`
      } else {
        url += `?env=${enviromentUrl}`
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions)

    yield put({ type: "LIST_GUEST_DIRECTORY_CATEGORY_RESPONSE_GET", value: response })
  } catch (error) {
    yield put({ type: "LIST_GUEST_DIRECTORY_CATEGORY_RESPONSE_GET", value: error })
  }
}

function* getGuestDirectoryCategory(actions) {
  const uuid = getSetCookie()
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    }

    const requestOptions = {
      headers: headers,
    }

    let url =
      actions.query === null
        ? apiUrl + "/opa-hotel-directory-categories/"
        : apiUrl + "/opa-hotel-directory-categories/" + actions.query

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`
      } else {
        url += `?env=${enviromentUrl}`
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions)

    yield put({ type: "GUEST_DIRECTORY_CATEGORY_RESPONSE_GET", value: response })
  } catch (error) {
    yield put({ type: "GUEST_DIRECTORY_CATEGORY_RESPONSE_GET", value: error })
  }
}

function* addGuestDirectoryCategory(actions) {
  const uuid = getSetCookie()
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    }

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    }

    let url = apiUrl + "/opa-hotel-directory-categories"

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`
      } else {
        url += `?env=${enviromentUrl}`
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions)

    let responseStatus = "warning"
    if (response) {
      if (response.createdAt || response.uuid) {
        responseStatus = "success"
      } else {
        responseStatus = "error"
      }
    }

    yield put({
      type: "GUEST_DIRECTORY_CATEGORY_RESPONSE_ADD",
      value: {
        ...response,
        responseStatus,
      },
    })
  } catch (error) {
    yield put({
      type: "GUEST_DIRECTORY_CATEGORY_RESPONSE_ADD",
      value: {
        ...error,
        responseStatus: "error",
      },
    })
  }
}

function* updateGuestDirectoryCategory(actions) {
  const uuid = getSetCookie()
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    }

    const formData = { ...actions.form }

    if (formData.uuid) {
      delete formData.uuid
    }

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(formData),
    }

    let url = `${apiUrl}/opa-hotel-directory-categories/${actions.categoryUuid}`

    if (enviromentUrl !== "") {
      url += url.includes("?") ? `&env=${enviromentUrl}` : `?env=${enviromentUrl}`
    }

    const response = yield call(apiCall, "PATCH", url, requestOptions)

    let responseStatus = "warning"
    if (response) {
      if (response.updatedAt || response.uuid) {
        responseStatus = "success"
      } else {
        responseStatus = "error"
      }
    }

    yield put({
      type: "GUEST_DIRECTORY_CATEGORY_RESPONSE_UPDATE",
      value: {
        ...response,
        responseStatus,
      },
    })
  } catch (error) {
    yield put({
      type: "GUEST_DIRECTORY_CATEGORY_RESPONSE_UPDATE",
      value: {
        ...error,
        responseStatus: "error",
      },
    })
  }
}

function* deleteGuestDirectoryCategory(actions) {
  const uuid = getSetCookie()
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    }

    const requestOptions = {
      headers: headers,
    }

    let url = apiUrl + "/opa-hotel-directory-categories/" + actions.categoryUuid

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`
      } else {
        url += `?env=${enviromentUrl}`
      }
    }

    const response = yield call(apiCall, "DELETE", url, requestOptions)

    let responseStatus = "warning"
    if (response) {
      if (response.status == 200 || response.status == 204) {
        responseStatus = "success"
      } else {
        responseStatus = "error"
      }
    }

    yield put({
      type: "GUEST_DIRECTORY_CATEGORY_RESPONSE_DELETE",
      value: { ...response, responseStatus },
    })

    return response
  } catch (error) {
    yield put({
      type: "GUEST_DIRECTORY_CATEGORY_RESPONSE_DELETE",
      value: { ...error, responseStatus: "error" },
    })
    throw error
  }
}

function* addGuestDirectory(actions) {
  const uuid = getSetCookie()
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    }

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    }

    let url = apiUrl + "/opa-hotel-directory-entries"

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`
      } else {
        url += `?env=${enviromentUrl}`
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions)

    let responseStatus = "warning"
    if (response) {
      if (response.createdAt || response.uuid) {
        responseStatus = "success"
      } else {
        responseStatus = "error"
      }
    }

    yield put({
      type: "GUEST_DIRECTORY_RESPONSE_ADD",
      value: {
        ...response,
        responseStatus,
      },
    })
  } catch (error) {
    yield put({
      type: "GUEST_DIRECTORY_RESPONSE_ADD",
      value: {
        ...error,
        responseStatus: "error",
      },
    })
  }
}

function* updateGuestDirectory(actions) {
  const uuid = getSetCookie()
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    }

    const formData = { ...actions.form }

    if (formData.uuid) {
      delete formData.uuid
    }

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(formData),
    }

    let url = `${apiUrl}/opa-hotel-directory-entries/${actions.entryUuid}`

    if (enviromentUrl !== "") {
      url += url.includes("?") ? `&env=${enviromentUrl}` : `?env=${enviromentUrl}`
    }

    const response = yield call(apiCall, "PATCH", url, requestOptions)

    let responseStatus = "warning"
    if (response) {
      if (response.updatedAt || response.uuid) {
        responseStatus = "success"
      } else {
        responseStatus = "error"
      }
    }

    yield put({
      type: "GUEST_DIRECTORY_RESPONSE_UPDATE",
      value: {
        ...response,
        responseStatus,
      },
    })
  } catch (error) {
    yield put({
      type: "GUEST_DIRECTORY_RESPONSE_UPDATE",
      value: {
        ...error,
        responseStatus: "error",
      },
    })
  }
}

function* deleteGuestDirectory(actions) {
  const uuid = getSetCookie()
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    }

    const requestOptions = {
      headers: headers,
    }

    let url = apiUrl + "/opa-hotel-directory-entries/" + actions.entryUuid

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`
      } else {
        url += `?env=${enviromentUrl}`
      }
    }

    const response = yield call(apiCall, "DELETE", url, requestOptions)

    let responseStatus = "warning"
    if (response) {
      if (response.status == 200 || response.status == 204) {
        responseStatus = "success"
      } else {
        responseStatus = "error"
      }
    }

    yield put({
      type: "GUEST_DIRECTORY_RESPONSE_DELETE",
      value: { ...response, responseStatus },
    })

    return response
  } catch (error) {
    yield put({
      type: "GUEST_DIRECTORY_RESPONSE_DELETE",
      value: { ...error, responseStatus: "error" },
    })
    throw error
  }
}

function* getGuestDirectoryFiles(actions) {
  const uuid = getSetCookie()
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    }

    const requestOptions = {
      headers: headers,
    }

    let url = `${apiUrl}/opa-hotel-directory-entries/${actions.entryUuid}/files`

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`
      } else {
        url += `?env=${enviromentUrl}`
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions)

    yield put({ type: "GUEST_DIRECTORY_FILES_RESPONSE_GET", value: response })
  } catch (error) {
    yield put({ type: "GUEST_DIRECTORY_FILES_RESPONSE_GET", value: error })
  }
}

function* addGuestDirectoryFile(actions) {
  const uuid = getSetCookie()
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    }
    const uploadHeaders = {
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    }

    const fileData = { ...actions.form }
    const fileToUpload = fileData.file
    delete fileData.file

    if (fileToUpload) {
      const uploadFormData = new FormData()
      uploadFormData.append("file", fileToUpload)
      uploadFormData.append("folder", actions.entryUuid)

      let uploadUrl = `${apiUrl}/opa-hotel-directory-entries/upload-file`

      if (enviromentUrl !== "") {
        if (uploadUrl.includes("?")) {
          uploadUrl += `&env=${enviromentUrl}`
        } else {
          uploadUrl += `?env=${enviromentUrl}`
        }
      }

      const uploadResponse = yield call(apiCall, "POST", uploadUrl, {
        headers: uploadHeaders,
        body: uploadFormData,
      })

      if (!uploadResponse?.file?.url) {
        throw new Error(uploadResponse?.error || "Failed to upload guest directory file")
      }

      const uploadedFileName = uploadResponse.file.name || fileToUpload.name || fileData.name
      fileData.uri = uploadResponse.file.key || uploadResponse.file.url
      fileData.externalId =
        uploadResponse.file.reference ||
        uploadResponse.file.key ||
        fileData.externalId ||
        ""
      fileData.name = fileData.name || uploadedFileName
    }

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(fileData),
    }

    let url = `${apiUrl}/opa-hotel-directory-entries/${actions.entryUuid}/files`

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`
      } else {
        url += `?env=${enviromentUrl}`
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions)

    let responseStatus = "warning"
    if (response) {
      if (response.createdAt || response.uuid) {
        responseStatus = "success"
      } else {
        responseStatus = "error"
      }
    }

    yield put({
      type: "GUEST_DIRECTORY_FILE_RESPONSE_ADD",
      value: {
        ...response,
        responseStatus,
      },
    })
  } catch (error) {
    yield put({
      type: "GUEST_DIRECTORY_FILE_RESPONSE_ADD",
      value: {
        ...error,
        responseStatus: "error",
      },
    })
  }
}

function* updateGuestDirectoryFile(actions) {
  const uuid = getSetCookie()
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    }

    const formData = { ...actions.form }

    if (formData.uuid) {
      delete formData.uuid
    }

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(formData),
    }

    let url = `${apiUrl}/opa-hotel-directory-entries/${actions.entryUuid}/files/${actions.fileUuid}`

    if (enviromentUrl !== "") {
      url += url.includes("?") ? `&env=${enviromentUrl}` : `?env=${enviromentUrl}`
    }

    const response = yield call(apiCall, "PATCH", url, requestOptions)

    let responseStatus = "warning"
    if (response) {
      if (response.updatedAt || response.uuid) {
        responseStatus = "success"
      } else {
        responseStatus = "error"
      }
    }

    yield put({
      type: "GUEST_DIRECTORY_FILE_RESPONSE_UPDATE",
      value: {
        ...response,
        responseStatus,
      },
    })
  } catch (error) {
    yield put({
      type: "GUEST_DIRECTORY_FILE_RESPONSE_UPDATE",
      value: {
        ...error,
        responseStatus: "error",
      },
    })
  }
}

function* deleteGuestDirectoryFile(actions) {
  const uuid = getSetCookie()
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    }

    const requestOptions = {
      headers: headers,
    }

    let url = `${apiUrl}/opa-hotel-directory-entries/${actions.entryUuid}/files/${actions.fileUuid}`

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`
      } else {
        url += `?env=${enviromentUrl}`
      }
    }

    const response = yield call(apiCall, "DELETE", url, requestOptions)

    let responseStatus = "warning"
    if (response) {
      if (response.status == 200 || response.status == 204) {
        responseStatus = "success"
      } else {
        responseStatus = "error"
      }
    }

    yield put({
      type: "GUEST_DIRECTORY_FILE_RESPONSE_DELETE",
      value: { ...response, responseStatus },
    })

    return response
  } catch (error) {
    yield put({
      type: "GUEST_DIRECTORY_FILE_RESPONSE_DELETE",
      value: { ...error, responseStatus: "error" },
    })
    throw error
  }
}

function* getGuestDirectoryImages(actions) {
  const uuid = getSetCookie()
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    }

    const requestOptions = {
      headers: headers,
    }

    let url = `${apiUrl}/opa-hotel-directory-entries/${actions.entryUuid}/images`

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`
      } else {
        url += `?env=${enviromentUrl}`
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions)

    yield put({ type: "GUEST_DIRECTORY_IMAGES_RESPONSE_GET", value: response })
  } catch (error) {
    yield put({ type: "GUEST_DIRECTORY_IMAGES_RESPONSE_GET", value: error })
  }
}

function* addGuestDirectoryImage(actions) {
  const uuid = getSetCookie()
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    }

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    }

    let url = `${apiUrl}/opa-hotel-directory-entries/${actions.entryUuid}/images`

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`
      } else {
        url += `?env=${enviromentUrl}`
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions)

    let responseStatus = "warning"
    if (response) {
      if (response.createdAt || response.uuid) {
        responseStatus = "success"
      } else {
        responseStatus = "error"
      }
    }

    yield put({
      type: "GUEST_DIRECTORY_IMAGE_RESPONSE_ADD",
      value: {
        ...response,
        responseStatus,
      },
    })
  } catch (error) {
    yield put({
      type: "GUEST_DIRECTORY_IMAGE_RESPONSE_ADD",
      value: {
        ...error,
        responseStatus: "error",
      },
    })
  }
}

function* updateGuestDirectoryImage(actions) {
  const uuid = getSetCookie()
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    }

    const formData = { ...actions.form }

    if (formData.uuid) {
      delete formData.uuid
    }

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(formData),
    }

    let url = `${apiUrl}/opa-hotel-directory-entries/${actions.entryUuid}/images/${actions.imageUuid}`

    if (enviromentUrl !== "") {
      url += url.includes("?") ? `&env=${enviromentUrl}` : `?env=${enviromentUrl}`
    }

    const response = yield call(apiCall, "PATCH", url, requestOptions)

    let responseStatus = "warning"
    if (response) {
      if (response.updatedAt || response.uuid) {
        responseStatus = "success"
      } else {
        responseStatus = "error"
      }
    }

    yield put({
      type: "GUEST_DIRECTORY_IMAGE_RESPONSE_UPDATE",
      value: {
        ...response,
        responseStatus,
      },
    })
  } catch (error) {
    yield put({
      type: "GUEST_DIRECTORY_IMAGE_RESPONSE_UPDATE",
      value: {
        ...error,
        responseStatus: "error",
      },
    })
  }
}

function* deleteGuestDirectoryImage(actions) {
  const uuid = getSetCookie()
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    }

    const requestOptions = {
      headers: headers,
    }

    let url = `${apiUrl}/opa-hotel-directory-entries/${actions.entryUuid}/images/${actions.imageUuid}`

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`
      } else {
        url += `?env=${enviromentUrl}`
      }
    }

    const response = yield call(apiCall, "DELETE", url, requestOptions)

    let responseStatus = "warning"
    if (response) {
      if (response.status == 200 || response.status == 204) {
        responseStatus = "success"
      } else {
        responseStatus = "error"
      }
    }

    yield put({
      type: "GUEST_DIRECTORY_IMAGE_RESPONSE_DELETE",
      value: { ...response, responseStatus },
    })

    return response
  } catch (error) {
    yield put({
      type: "GUEST_DIRECTORY_IMAGE_RESPONSE_DELETE",
      value: { ...error, responseStatus: "error" },
    })
    throw error
  }
}

export function* getSagaGuestDirectoryList() {
  yield takeEvery("GET_LIST_GUEST_DIRECTORY", getGuestDirectoryList)
}

export function* getSagaGuestDirectory() {
  yield takeEvery("GET_GUEST_DIRECTORY", getGuestDirectory)
}

export function* getSagaGuestDirectoryCategoryList() {
  yield takeEvery("GET_LIST_GUEST_DIRECTORY_CATEGORY", getGuestDirectoryCategoryList)
}

export function* getSagaGuestDirectoryCategory() {
  yield takeEvery("GET_GUEST_DIRECTORY_CATEGORY", getGuestDirectoryCategory)
}

export function* addSagaGuestDirectoryCategory() {
  yield takeEvery("ADD_GUEST_DIRECTORY_CATEGORY", addGuestDirectoryCategory)
}

export function* updateSagaGuestDirectoryCategory() {
  yield takeEvery("UPDATE_GUEST_DIRECTORY_CATEGORY", updateGuestDirectoryCategory)
}

export function* deleteSagaGuestDirectoryCategory() {
  yield takeEvery("DELETE_GUEST_DIRECTORY_CATEGORY", deleteGuestDirectoryCategory)
}

export function* addSagaGuestDirectory() {
  yield takeEvery("ADD_GUEST_DIRECTORY", addGuestDirectory)
}

export function* updateSagaGuestDirectory() {
  yield takeEvery("UPDATE_GUEST_DIRECTORY", updateGuestDirectory)
}

export function* deleteSagaGuestDirectory() {
  yield takeEvery("DELETE_GUEST_DIRECTORY", deleteGuestDirectory)
}

export function* getSagaGuestDirectoryFiles() {
  yield takeEvery("GET_GUEST_DIRECTORY_FILES", getGuestDirectoryFiles)
}

export function* addSagaGuestDirectoryFile() {
  yield takeEvery("ADD_GUEST_DIRECTORY_FILE", addGuestDirectoryFile)
}

export function* updateSagaGuestDirectoryFile() {
  yield takeEvery("UPDATE_GUEST_DIRECTORY_FILE", updateGuestDirectoryFile)
}

export function* deleteSagaGuestDirectoryFile() {
  yield takeEvery("DELETE_GUEST_DIRECTORY_FILE", deleteGuestDirectoryFile)
}

export function* getSagaGuestDirectoryImages() {
  yield takeEvery("GET_GUEST_DIRECTORY_IMAGES", getGuestDirectoryImages)
}

export function* addSagaGuestDirectoryImage() {
  yield takeEvery("ADD_GUEST_DIRECTORY_IMAGE", addGuestDirectoryImage)
}

export function* updateSagaGuestDirectoryImage() {
  yield takeEvery("UPDATE_GUEST_DIRECTORY_IMAGE", updateGuestDirectoryImage)
}

export function* deleteSagaGuestDirectoryImage() {
  yield takeEvery("DELETE_GUEST_DIRECTORY_IMAGE", deleteGuestDirectoryImage)
}
